import { useEffect } from 'react';
import { useEmbedBootstrap } from '../use-widget-bootstrap';

export function useWidgetSeo(pageTitle: string, description?: string) {
  let bootstrap: ReturnType<typeof useEmbedBootstrap> | null = null;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    bootstrap = useEmbedBootstrap();
  } catch {
    // fallback if rendered outside EmbedBootstrapProvider (e.g. isolated unit tests)
  }

  const orgName =
    bootstrap?.widgetConfig?.name?.trim() ||
    bootstrap?.globalWidgetConfig?.title?.trim() ||
    bootstrap?.guestShowcaseOrg?.name?.trim() ||
    'DomCRM';

  useEffect(() => {
    const titleClean = pageTitle.trim();
    let fullTitle = titleClean;
    if (titleClean) {
      if (titleClean.includes('|') || titleClean.includes('DomCRM')) {
        fullTitle = titleClean;
      } else {
        fullTitle = `${titleClean} | ${orgName}`;
      }
    } else {
      fullTitle = `${orgName} — Виджет`;
    }

    document.title = fullTitle;

    if (description) {
      let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = description;
    }
  }, [pageTitle, description, orgName]);
}
